import { render, staticRenderFns } from "./ConsultationsAndReworksGrid.vue?vue&type=template&id=4c71014a"
import script from "./ConsultationsAndReworksGrid.vue?vue&type=script&lang=js"
export * from "./ConsultationsAndReworksGrid.vue?vue&type=script&lang=js"
import style0 from "./ConsultationsAndReworksGrid.vue?vue&type=style&index=0&id=4c71014a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports